var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up-arrow 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.6044 20.8578C39.1319 20.5941 39.1319 19.7371 38.6044 19.4734C34.5171 17.2319 30.3637 15.1882 25.8808 14.0015C25.2215 13.8697 24.5623 14.5949 24.9578 15.1882C25.8808 16.5067 27.0015 17.6274 28.32 18.6163C19.0905 18.3526 9.53123 17.1 0.433491 19.2756C-0.225765 19.4074 -0.0939178 20.5281 0.565449 20.4621C9.99282 19.2756 19.3543 20.1986 28.7816 20.3303C27.7927 21.451 26.8039 22.5718 25.815 23.6266C25.3535 24.0881 25.6172 25.0771 26.4083 25.0111C30.7593 24.4836 34.8467 23.0332 38.6044 20.8578ZM30.7593 20.1326C31.3526 19.7371 31.2208 18.6163 30.2978 18.6163C30.2319 18.6163 30.166 18.6163 30.166 18.6163C29.3749 17.8252 28.5837 17.1 27.7926 16.243C30.8252 17.2978 33.66 18.6163 36.4948 20.1325C33.9237 21.451 31.2867 22.4399 28.4519 22.9673C29.1112 22.2421 29.7704 21.451 30.4956 20.7257C30.7593 20.5941 30.8252 20.3303 30.7593 20.1326Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow1);
export default __webpack_public_path__ + "static/media/up-arrow1.350e6850bd0e7faca1228b00962b2803.svg";
export { ForwardRef as ReactComponent };